var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m1Header'),_c('router-view',{key:_vm.router}),_c('div',{staticClass:"clear"}),_c('div',{staticClass:"mt"}),_c('m1-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }